var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"copyright-intro"},[_c('div',{staticClass:"question"},[_c('a',{attrs:{"href":"javascript:;"}},[_vm._v("常见问题")]),_vm._v(" | "),_c('a',{attrs:{"href":"javascript:;"}},[_vm._v("隐私政策")]),_vm._v(" | "),_c('a',{attrs:{"href":"javascript:;"}},[_vm._v("用户协议")])])])
}]

export { render, staticRenderFns }